import * as React from "react";
import i18next from "i18next";
import { useCallback, useEffect, useState } from "react";
import { ToolbarButton } from "./ToolbarButton";
import { useMapContext } from "../../Contexts/MapContext";
import { ToolbarSelect } from "./ToolbarSelect";
import { replaceParam } from "../Toc/helpers";
import { Widget } from "../enums";
import { useAppContext } from "../../Contexts/AppContext";
import classNames from "classnames";
import "./Toolbar.scss";

export const Toolbar = (): JSX.Element => {
    const { language } = useAppContext();
    const { configA, setWidget, drawType } = useMapContext();

    const [expanded, setExpanded] = useState<boolean>(true);

    useEffect(() => {
        !expanded && setWidget(undefined);
    }, [expanded]);

    const onClickMenu = useCallback(() => {
        setExpanded(!expanded);
    }, [expanded]);

    const onChangeLanguage = useCallback(
        (lang: string) => {
            if (lang.toLowerCase() !== language) {
                // localStorage.setItem("GeoLiteLanguage", lang);
                window.location.href = replaceParam("lang", lang);
            }
        },
        [language]
    );

    const widgets = configA && configA.widgets;
    const hasLayersWidget = widgets && (widgets.LayerList || widgets.LayerList === undefined);
    const hasSearchWidget = widgets && (widgets.Search || widgets.Search === undefined);
    const hasLanguageWidget = widgets && (widgets.Language || widgets.Language === undefined);
    const hasPrintWidget = widgets && (widgets.Print || widgets.Print === undefined);
    const hasDrawWidget = widgets && (widgets.Sketch || widgets.Sketch === undefined);
    const hasBookmarksWidget = widgets && (widgets.Bookmarks || widgets.Bookmarks === undefined);
    const hasConversionWidget = widgets && (widgets.CoordinateConversion || widgets.CoordinateConversion === undefined);
    const hasDataDownloadWidget = widgets && widgets.DataDownload;
    const hasHelpButton = configA && configA.customerRow?.helpLink;
    const hasMapDownloadWidget = widgets && widgets.MapDownload;

    const hasToolbar =
        hasLayersWidget ||
        hasSearchWidget ||
        hasDrawWidget ||
        hasBookmarksWidget ||
        hasConversionWidget ||
        hasDataDownloadWidget ||
        hasHelpButton ||
        hasMapDownloadWidget;

    return (
        <>
            {hasToolbar ? (
                <div className="toolbar">
                    <ToolbarButton
                        iconClassName="icon-geolite-menu"
                        onClick={onClickMenu}
                        title={i18next.t("closeOpenMenu")}
                    ></ToolbarButton>
                    {expanded && (
                        <div className={classNames("toolbar-buttons", { disabled: !!drawType })}>
                            {hasLayersWidget ? (
                                <ToolbarButton
                                    iconClassName="icon-geolite-layers"
                                    onClick={() => setWidget(Widget.Toc)}
                                    title={i18next.t("toolBar.toc")}
                                />
                            ) : null}{" "}
                            {hasSearchWidget ? (
                                <ToolbarButton
                                    iconClassName="icon-geolite-search"
                                    onClick={() => setWidget(Widget.Search)}
                                    title={i18next.t("search")}
                                />
                            ) : null}
                            {hasPrintWidget ? (
                                <ToolbarButton
                                    iconClassName="icon-geolite-print"
                                    onClick={() => setWidget(Widget.Print)}
                                    title={i18next.t("toolBar.print")}
                                />
                            ) : null}
                            {hasConversionWidget ? (
                                <ToolbarButton
                                    iconClassName="icon-geolite-convert"
                                    onClick={() => setWidget(Widget.Convert)}
                                    title={i18next.t("coordinates.coordinateConversion")}
                                />
                            ) : null}
                            {hasDrawWidget ? (
                                <ToolbarButton
                                    iconClassName="icon-geolite-functions"
                                    onClick={() => setWidget(Widget.Draw)}
                                    title={i18next.t("toolBar.sketch")}
                                />
                            ) : null}
                            {hasBookmarksWidget ? (
                                <ToolbarButton
                                    iconClassName="icon-geolite-mark"
                                    onClick={() => setWidget(Widget.Bookmarks)}
                                    title={i18next.t("toolBar.bookmarks")}
                                />
                            ) : null}
                            {hasDataDownloadWidget ? (
                                <ToolbarButton
                                    iconClassName="icon-geolite-sync-data-down"
                                    onClick={() => setWidget(Widget.DataDownload)}
                                    title={i18next.t("toolBar.dataDownload")}
                                />
                            ) : null}
                            {hasMapDownloadWidget ? (
                                <ToolbarButton
                                    iconClassName="icon-geolite-tripod"
                                    onClick={() => setWidget(Widget.MapDownload)}
                                    title={i18next.t("toolBar.mapDownload")}
                                />
                            ) : null}
                            {hasHelpButton ? (
                                <ToolbarButton
                                    iconClassName="icon-geolite-question-mark-circled"
                                    onClick={() => setWidget(Widget.Help)}
                                    title={i18next.t("toolBar.help")}
                                />
                            ) : null}
                            {hasLanguageWidget ? (
                                <ToolbarSelect
                                    value={language.toUpperCase()}
                                    values={configA.allLanguages}
                                    onChange={onChangeLanguage}
                                    title={i18next.t("toolBar.language")}
                                />
                            ) : null}
                        </div>
                    )}
                </div>
            ) : null}
        </>
    );
};
